module.exports = __webpack_public_path__ + "static/media/LivingClassAdmin_002.36de6818.png";